;(function () {
  'use strict'

  angular
    .module('contrast.loading')
    .factory('csRotatingLoadingMsgService', [
      'csLoadingMessages',
      csRotatingLoadingMsgService
    ])

  function csRotatingLoadingMsgService(csLoadingMessages) {
    var service = {
      getRandom: getRandom
    }

    return service

    function getRandom() {
      return csLoadingMessages[_.random(0, csLoadingMessages.length - 1)]
    }
  }
})()
